import React, { ReactElement } from 'react'
import NetworkRestricted from 'src/components/templates/NetworkRestricted'
import NoAuthorizations from 'src/components/templates/NoAuthorizations'
import { ForbiddenErrorCodeEnum } from 'src/slices/services/api'
import { useAppSelector } from 'src/store'

/**
 * 認可を取得できたが利用できる状態にないときに出す案内画面を返す。
 *
 * 判定を Root と PrivateRoute の両方に書くと、片方だけ直したときに画面ごとに
 * 挙動が食い違うため、ここに集約する。案内が不要なときは null を返す。
 */
const useAuthorizationGuidance = (): ReactElement | null => {
  const { status, error, authorizations } = useAppSelector(
    (state) => state.auth
  )

  // 許可されていないネットワークからのアクセスは、原因が分かる案内に振り分ける
  if (error?.code === ForbiddenErrorCodeEnum.NetworkRestricted) {
    return <NetworkRestricted />
  }

  // 取得に成功したが組織が0件のときは遷移先が無く、案内が無いとローディングのまま止まる
  if (status === 'succeeded' && authorizations.length === 0) {
    return <NoAuthorizations />
  }

  return null
}

export default useAuthorizationGuidance
